import Vue from 'vue'
import Vuetify, {
  VRow,
  VCol,
  VTextField,
  VTooltip,
  VCheckbox,
  VSelect,
} from 'vuetify/lib'
import { Ripple, Intersect, Touch, Resize } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
  components: { VRow, VTooltip, VCol, VTextField, VCheckbox, VSelect },
  directives: { Ripple, Intersect, Touch, Resize },
})

export default new Vuetify({
  theme: {
    themes: {
      dark: {
        primary: '#0AF167',
        secondary: '#0D0735',
        tertiary: '#39EAFD',
        accent: '#520099',
        info: '#00d3ee'
      },
    },
    dark: true,
    options: {
      customProperties: true
    }
  },
  icons: {
    iconfont: 'mdi',
  },
})
